import { parseAsString, useQueryState } from 'nuqs'

export function useProviderGameTypeSelector() {
	const [gameType, setGameType] = useQueryState(
		'providerGameType',
		parseAsString.withDefault('SLOT'),
	)

	return {
		gameType,
		setGameType,
	}
}
